var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2109_10722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.23057 9.03232C4.82597 9.46913 4.30013 9.77654 3.71973 9.91559C3.13933 10.0546 2.53051 10.019 1.97046 9.81333C1.41041 9.60762 0.924362 9.24106 0.573936 8.76012C0.22351 8.27917 0.0244932 7.70551 0.00211848 7.11188C-0.0202562 6.51824 0.135019 5.93136 0.448257 5.42564C0.761496 4.91993 1.21859 4.51817 1.76158 4.27129C2.30457 4.02441 2.909 3.94354 3.49824 4.03893C4.08747 4.13432 4.63498 4.40168 5.07132 4.8071L7.70174 3.10042C7.49154 2.58845 7.47822 2.01738 7.66433 1.49627C7.85044 0.975155 8.22294 0.540524 8.71067 0.275384C9.19841 0.0102451 9.7672 -0.0668201 10.3084 0.0589076C10.8496 0.184635 11.3253 0.504345 11.6447 0.956974C11.964 1.4096 12.1046 1.96343 12.0396 2.51268C11.9746 3.06193 11.7086 3.5681 11.2923 3.93453C10.8761 4.30096 10.3387 4.50196 9.78297 4.49915C9.22721 4.49633 8.69196 4.28989 8.27947 3.91926L5.68221 5.60395C5.90325 6.02138 6.02784 6.49629 6.02784 7.0002C6.02832 7.41069 5.94384 7.81689 5.77967 8.19348L9.56403 10.3116C9.91949 9.88646 10.4199 9.60653 10.9696 9.52526C11.5193 9.44398 12.0799 9.56706 12.5442 9.87098C13.0085 10.1749 13.344 10.6384 13.4867 11.1729C13.6294 11.7074 13.5692 12.2754 13.3177 12.7686C13.0662 13.2617 12.6409 13.6454 12.1231 13.8463C11.6053 14.0472 11.0313 14.0513 10.5107 13.8577C9.99006 13.6642 9.55933 13.2866 9.30075 12.7971C9.04218 12.3075 8.97387 11.7404 9.10888 11.2039L5.23007 9.03282L5.23057 9.03232Z",
    fill: "#97B7EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2109_10722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share_icon.2b7e23f83428a7d7745bec53993d404e.svg";
export { ForwardRef as ReactComponent };